document.addEventListener("DOMContentLoaded", function () {

  // Check if current URL matches one of the allowed product pages
  const allowedUrls = [
    "https://xv1.co/products/xv1-green-superfood?variant=50898267177092",
    "https://xv1.co/products/xv1-creatine-gummies-copy?variant=50913181696132",
  ];

  if (!allowedUrls.includes(window.location.href)) {
    return; // Exit if not on an allowed page
  }
  
  // Wait for initial elements to be available
  setTimeout(function () {
    // Find the action button that needs to be modified
    const actionButton = document.querySelector(
      "[data-instant-action-type=redirect-to-cart][conditionals]"
    );

    if (!actionButton) return;

    const buttonText =
      actionButton.querySelector("p") ||
      actionButton.querySelector(".instant-rich-text");
    const variantId = actionButton.getAttribute(
      "data-instant-action-variant-id"
    );

    // Function to update button based on selected plan
    function updateButtonBasedOnSelection() {
      // Find all selling plan selectors
      const selectors = document.querySelectorAll(
        ".instant-selling-plan-selector"
      );

      // Look for the active one
      let activeSelector = null;
      selectors.forEach((selector) => {
        if (selector.getAttribute("data-instant-state") === "active") {
          activeSelector = selector;
        }
      });

      if (!activeSelector) return;

      // Get the selling plan ID
      const sellingPlanId = activeSelector.getAttribute(
        "data-instant-selling-plan-id"
      );

      // Check if one-time purchase or subscription
      if (sellingPlanId === "one-time-purchase") {
        // if sale badge is present, set quantity to 2 else 1
        const saleBadge = actionButton.getAttribute("data-sale-badge");
        const quantity = saleBadge ? 2 : 1;
        // One-time purchase: Add to Cart
        if (buttonText) buttonText.textContent = "Add to Cart";
        actionButton.href = `${window.routes.cart_url}/${variantId}:${quantity}?storefront=true`;
        actionButton.setAttribute(
          "data-instant-action-type",
          "redirect-to-cart"
        );

        // Ensure default click behavior for one-time purchases
        actionButton.onclick = null;
      } else {
        // Subscription: Clear cart then direct to Checkout
        if (buttonText) buttonText.textContent = "Checkout";

        // let finalSellingPlanId =
        //   window.currentProductVariant.selling_plan_allocations[0] //Bad option for implementing here, used harcoded [0] instead of the id from the selling plan sellector 
        //     .selling_plan_id;
        let finalSellingPlanId = sellingPlanId;
        const checkoutUrl = `${window.location.origin}/cart/add?items[][id]=${variantId}&items[][quantity]=1&items[][selling_plan]=${finalSellingPlanId}&return_to=/checkout`;

        // Override the click behavior for subscription
        actionButton.onclick = function (e) {
          e.preventDefault();

          if (actionButton.getAttribute("data-instant-disabled") == "true") {
            return;
          }
          // Show loading state
          if (buttonText) buttonText.textContent = "Processing...";
          actionButton.classList.add("processing");

          // Clear the cart first
          fetch("/cart/clear.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((response) => response.json())
            .then(() => {
              // After cart is cleared, redirect to checkout
              window.location.href = checkoutUrl;
            })
            .catch((error) => {
              console.error("Error clearing cart:", error);
              // If clearing fails, just redirect anyway
              window.location.href = checkoutUrl;
            });

          return false;
        };

        // Keep the href for accessibility and non-JS fallback
        actionButton.href = "#";
        actionButton.setAttribute(
          "data-instant-action-type",
          "custom-checkout"
        );
      }
    }

    // Rest of the code remains unchanged
    const sellingPlanObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "data-instant-state") {
          updateButtonBasedOnSelection();
        }
      });
    });

    // Observe all selling plan selectors
    document
      .querySelectorAll(".instant-selling-plan-selector")
      .forEach((selector) => {
        sellingPlanObserver.observe(selector, { attributes: true });
      });

    // Handle initial state
    updateButtonBasedOnSelection();

    // Handle potential dynamic changes to the page
    const bodyObserver = new MutationObserver((mutations) => {
      const newSelectors = document.querySelectorAll(
        ".instant-selling-plan-selector:not([data-checkout-observed])"
      );

      if (newSelectors.length > 0) {
        newSelectors.forEach((selector) => {
          sellingPlanObserver.observe(selector, { attributes: true });
          // Mark as observed to avoid duplicates
          selector.setAttribute("data-checkout-observed", "true");
        });

        // Update button state
        updateButtonBasedOnSelection();
      }
    });

    // Watch for new selling plan selectors being added dynamically
    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Ensure it works after auto-selection scripts
    setTimeout(updateButtonBasedOnSelection, 600);
  }, 200);
});
